<template>
  <v-container>
    <Loading v-model="loading"></Loading>

    <v-form v-model="valid" ref="form">
      <v-container>

        <h2>受験者の登録</h2>

        <v-row>
          <v-col>
            <v-text-field label="姓(必須)" v-model="form.lastName" placeholder="姓"
                          :disabled="disableEditName"
                          :rules="[rules.required]"></v-text-field>
          </v-col>
          <!--          <v-col>-->
          <!--            <v-text-field label="ミドルネーム" v-model="form.middleName"-->
          <!--                          :disabled="disableEditName"></v-text-field>-->
          <!--          </v-col>-->
          <v-col>
            <v-text-field label="名(必須)" v-model="form.firstName" placeholder="名"
                          :disabled="disableEditName"
                          :rules="[rules.required]"></v-text-field>
          </v-col>
        </v-row>
        <!--        <p class="text-caption text-left mt-5">-->
        <!--          ※氏名が漢字の場合であれば必ず入力してください。<br>-->
        <!--          ※外国籍かつ日本居住者は在留カードに記載されている通りに入力してください。<br>-->
        <!--        </p>-->
        <v-row>
          <v-col>
            <v-text-field label="姓(フリガナ)(必須)" v-model="form.lastNameKana"
                          :disabled="disableEditName"
                          :rules="[rules.required, rules.kana]"></v-text-field>
          </v-col>
          <!--          <v-col>-->
          <!--            <v-text-field label="ミドルネーム(フリガナ)" v-model="form.middleNameKana"-->
          <!--                          :disabled="disableEditName"-->
          <!--                          :rules="[rules.kana]"></v-text-field>-->
          <!--          </v-col>-->
          <v-col>
            <v-text-field label="名(フリガナ)(必須)" v-model="form.firstNameKana"
                          :disabled="disableEditName"
                          :rules="[rules.required, rules.kana]"></v-text-field>
          </v-col>
        </v-row>

        <v-radio-group
          v-model="form.gender"
          row
          :disabled="disableEditName"
          :rules="[rules.required]"
        >
          <template v-slot:label>
            性別(必須)
          </template>
          <v-radio
            label="男"
            value="男"
          ></v-radio>
          <v-radio
            label="女"
            value="女"
          ></v-radio>
        </v-radio-group>

        <DatePicker v-model="form.birthdate"
                    label="生年月日(必須)"
                    baseDate="1995-01-01"
                    :rules="[rules.required]"
                    :disabled="disableEditName"
                    class="mt-12"
        ></DatePicker>


        <v-row
          class="mt-12">
          <v-col class="text-center" cols="12" md="6">
            <v-img :src="form.pictureUrl" width="240" height="320" v-if="form.pictureUrl" class="ma-auto"
                   @click="clickUpload"
                   :disabled="disableEditName"
            ></v-img>
            <v-card
              v-else
              class="ma-auto"
              color="grey lighten-1"
              width="240" height="320"
              @click="clickUpload"
            ></v-card>
            <v-btn
              color="primary"
              class="text-none"
              rounded
              depressed
              :loading="isSelecting"
              @click="clickUpload"
              :disabled="disableEditName"
            >
              <v-icon left>
                cloud_upload
              </v-icon>
              写真をアップロード
            </v-btn>
            <v-text-field :rules="[rules.photo]" class="photo-message"></v-text-field>
            <!--            <v-file-input label="写真" @change="uploadPhoto"-->
            <!--                          :rules="[rules.photo]"-->
            <!--                          accept="image/*"-->
            <!--                          class="d-none"-->
            <!--                          ref="uploader"-->
            <!--            ></v-file-input>-->
            <input type="file"
                   @change="onFileChanged"
                   :rules="[rules.photo]"
                   accept="image/*"
                   class="d-none"
                   ref="uploader"/>
          </v-col>
          <v-col>
            <DatePicker v-model="form.pictureDate" label="写真撮影年月(必須)" month
                        :min="minPictureDate"
                        :disabled="disableEditName"
                        :rules="[rules.required]"></DatePicker>
            <p class="text-caption text-left" style="padding-top: 2em">
              ※申請日より３ヶ月以内に撮影したもの。<br>
              ※ファイルサイズ10MB（メガバイト）以下、縦320ピクセル×横240ピクセルのJPEG（ジェイペグ）形式のデジタル写真（規定外のサイズはアップロード時に自動調整されます）。<br>
              ※写真はカラー、または白黒で無背景のもの（白地または背景の色が強くないもの）。<br>
              ※帽子、マスク、サングラス等を着用していないもの。<br>
              ※ご本人のみが写っているもの（ほかの人物及び特定できる文字や建物が映っていないもの）。<br>
              ※正面を向いて本人の肩から上、頭頂部まで顔や輪郭がはっきりと判別できるもの。<br>
              ※受験時に眼鏡を使用する場合、眼鏡をかけて撮影したもの。<br>
              ※アップロードされた画像の向きが正常でない場合（上下が反対等）は、デバイス（スマートフォン、iPad等）の縦横を変えて再度撮影し画像のアップロードをしてください。
            </p>
          </v-col>
        </v-row>

        <v-text-field label="最終学歴（必須）" v-model="form.academicBackground" :rules="[rules.required]"
                      messages="最後に卒業した学校名を記入する。中学校卒業以上で旧制の場合は「旧制」と記入する。"
                      class="mb-3"
                      :disabled="disableEditName"
        ></v-text-field>

        <v-text-field label="郵便番号(必須)※半角数字、ハイフン有り" v-model="form.zipcode"
                      validate-on-blur
                      :rules="[rules.hankaku,rules.zip, rules.required]"
                      @change="checkZipcode($event,true)"
                      :disabled="disableEditName"
                      :error-messages="zipcodeError"></v-text-field>
        <v-text-field label="都道府県（必須）" v-model="form.prefecture" :rules="[rules.required]"
                      :disabled="disableEditName"></v-text-field>
        <v-text-field label="市区町村（必須）入力例：千代田区霞が関３丁目" v-model="form.address" :rules="[rules.required]"
                      :disabled="disableEditName"></v-text-field>
        <v-text-field label="番地（必須）入力例：３番３号" v-model="form.address2" :rules="[rules.required]"
                      :disabled="disableEditName"></v-text-field>
        <v-text-field label="ビル名・部屋番号" v-model="form.address3"
                      :disabled="disableEditName"></v-text-field>

        <v-text-field label="電話番号（必須） 半角数字、ハイフン有り。" v-model="form.tel"
                      :rules="[rules.tel, rules.required]"
                      :disabled="disableEditName"></v-text-field>

        <v-text-field label="勤務先名(必須)" v-model="form.organization" :rules="[rules.required]"
                      :disabled="disableEditName"></v-text-field>

        <v-text-field label="勤務先郵便番号（必須）" v-model="form.organizationZipcode"
                      validate-on-blur
                      :rules="[rules.hankaku,rules.zip, rules.required]"
                      @change="checkZipcodeOffice($event,true)"
                      :disabled="disableEditName"
                      :error-messages="zipcodeError"></v-text-field>
        <v-text-field label="勤務先都道府県（必須）" v-model="form.organizationPrefecture" :rules="[rules.required]"
                      :disabled="disableEditName"></v-text-field>
        <v-text-field label="勤務先市区町村（必須）入力例：千代田区霞が関３丁目" v-model="form.organizationAddress"
                      :rules="[rules.required]"
                      :disabled="disableEditName"></v-text-field>
        <v-text-field label="勤務先番地（必須）入力例：３番３号" v-model="form.organizationAddress2"
                      :rules="[rules.required]"
                      :disabled="disableEditName"></v-text-field>
        <v-text-field label="勤務先ビル名・部屋番号" v-model="form.organizationAddress3"
                      :disabled="disableEditName"></v-text-field>

        <v-text-field label="勤務先電話番号（必須）" v-model="form.organizationTel" :rules="[rules.tel, rules.required]"
                      :disabled="disableEditName"></v-text-field>
        <v-text-field type="number" label="勤続年数（必須）" v-model="form.serviceYears" :rules="[rules.required]" min="0"
                      messages="現在の勤務先での勤務年数を記入（本部・支部等での異動があった場合は全て通算する。1年に満たない場合は0年と記入する。）"
                      class="mb-3"
                      :disabled="disableEditName"
        ></v-text-field>

<!--        <v-select label="所属団体（必須）"-->
<!--                  v-model="form.affiliation"-->
<!--                  :disabled="disableEditName"-->
<!--                  :items="[-->
<!--  '北海道中小企業団体中央会',-->
<!--  '青森県中小企業団体中央会',-->
<!--  '岩手県中小企業団体中央会',-->
<!--  '宮城県中小企業団体中央会',-->
<!--  '秋田県中小企業団体中央会',-->
<!--  '山形県中小企業団体中央会',-->
<!--  '福島県中小企業団体中央会',-->
<!--  '茨城県中小企業団体中央会',-->
<!--  '栃木県中小企業団体中央会',-->
<!--  '群馬県中小企業団体中央会',-->
<!--  '埼玉県中小企業団体中央会',-->
<!--  '千葉県中小企業団体中央会',-->
<!--  '東京都中小企業団体中央会',-->
<!--  '神奈川県中小企業団体中央会',-->
<!--  '新潟県中小企業団体中央会',-->
<!--  '富山県中小企業団体中央会',-->
<!--  '石川県中小企業団体中央会',-->
<!--  '福井県中小企業団体中央会',-->
<!--  '山梨県中小企業団体中央会',-->
<!--  '長野県中小企業団体中央会',-->
<!--  '岐阜県中小企業団体中央会',-->
<!--  '静岡県中小企業団体中央会',-->
<!--  '愛知県中小企業団体中央会',-->
<!--  '三重県中小企業団体中央会',-->
<!--  '滋賀県中小企業団体中央会',-->
<!--  '京都府中小企業団体中央会',-->
<!--  '大阪府中小企業団体中央会',-->
<!--  '兵庫県中小企業団体中央会',-->
<!--  '奈良県中小企業団体中央会',-->
<!--  '和歌山県中小企業団体中央会',-->
<!--  '鳥取県中小企業団体中央会',-->
<!--  '島根県中小企業団体中央会',-->
<!--  '岡山県中小企業団体中央会',-->
<!--  '広島県中小企業団体中央会',-->
<!--  '山口県中小企業団体中央会',-->
<!--  '徳島県中小企業団体中央会',-->
<!--  '香川県中小企業団体中央会',-->
<!--  '愛媛県中小企業団体中央会',-->
<!--  '高知県中小企業団体中央会',-->
<!--  '福岡県中小企業団体中央会',-->
<!--  '佐賀県中小企業団体中央会',-->
<!--  '長崎県中小企業団体中央会',-->
<!--  '熊本県中小企業団体中央会',-->
<!--  '大分県中小企業団体中央会',-->
<!--  '宮崎県中小企業団体中央会',-->
<!--  '鹿児島県中小企業団体中央会',-->
<!--  '沖縄県中小企業団体中央会'-->
<!--]"-->
<!--                  :rules="[rules.required]"></v-select>-->

        <p class="text-caption text-center">
          ※「確定する」ボタンをクリックても画面上部に「確定しました」と表示が出ない場合は、<br>
          　必須項目に未入力・未登録の項目があります。該当箇所に赤字で不備内容が表示されますので、<br>
          　表示を確認の上、全て入力・登録をしてください。
        </p>
        <div class="text-center">
          <v-btn to="/mypage" class="mx-2">マイページに戻る</v-btn>
          <v-btn @click.stop="save" class="mx-2" v-if="!submitted">一時保存する</v-btn>
          <v-btn color="primary" @click.stop="submit" class="mx-2"
                 v-if="!disableEditName"
                 :disabled="disableEditName">確定する
          </v-btn>
        </div>
      </v-container>
    </v-form>

  </v-container>
</template>
<script>
import axios from 'axios'
import dayjs from 'dayjs'
import DatePicker from '../components/DatePicker'
import {prefectures} from '../../data/prefectures.json'
import countries from '../../data/countries.json'
import Rules from '../mixins/RulesMixin'
import Loading from '../components/Loading'
import ZipCodeChecker from '../mixins/ZipCodeChecker'
import {mapGetters} from 'vuex'

export default {
  components: {DatePicker, Loading},
  mixins: [Rules, ZipCodeChecker],
  data() {
    return {
      loading: true,
      form: {
        lastName: '',
        firstName: '',
        middleName: '',
        lastNameKana: '',
        firstNameKana: '',
        middleNameKana: '',
        gender: '',
        birthdate: '',
        permanentAddress: '',
        nationality: '',
        nationalityOther: '',
        picture: '',
        pictureDate: '',
        pictureUrl: '',

        zipcode: '',
        prefecture: '',
        address: '',
        address2: '',
        address3: '',
        organization: '',
        organizationZipcode: '',
        organizationPrefecture: '',
        organizationAddress: '',
        organizationAddress2: '',
        organizationAddress3: '',
        organizationTel: '',
        serviceYears: '',
        affiliation: '',

        tel: '',
        fax: '',
        consideration: '',
        documents: []
      },
      rules: {
        photo: (v) => {
          return (!!this.form.pictureUrl) || '必須項目です'
        },
        permanentAddress: (v) => {
          return (!!v || !!this.form.nationality) || '日本国籍かつ日本居住者の場合は必須項目です'
        },
        nationality: (v) => {
          return (!!v || !!this.form.permanentAddress) || '外国籍の場合、または日本国籍かつ外国居住者の場合は必須項目です'
        },
        nationalityOther: (v) => {
          return (!!v || this.form.nationality != 'その他') || '国籍が「その他」の場合必須'
        },
        notifyAddress: (v) => {
          return !!this.form.notifySameAddress || !!v || '必須項目です'
        },
        urgentTypeOther: (v) => {
          return (!!v || this.form.urgentType != 'その他') || '緊急連絡先種別が「その他」の場合必須'
        },
        notifyZipcode: (v) => {
          return !this.notifyZipcodeError || this.notifyZipcodeError
        }
        //   required: v => !!v || '必須項目です',
        //   tel: v => /^[+]?[\d-]*$/.test(v) || '番号が正しくありません',
        //   zip: v => /^[\d-]*$/.test(v) || '番号が正しくありません',
        //   kana: v => /^[ァ-ヶー　]*$/.test(v) || '全角カタカナで入力してください',
      },
      schema: {
        birthdate: {
          type: 'text',
          title: '生年月日'
        }
      },
      valid: false,
      countries: [],
      prefectures: [],
      urgentTypes: [
        '自宅',
        '携帯電話',
        '勤務先',
        'その他'
      ],
      // telRule: [this.rules.tel],
      // zipcodeRule: [this.rules.zipcode]
      isSelecting: false,
      zipcodeError: [],
      zipcodeInJapan: false,
      notifyZipcodeError: [],
      yearFormat: (year) => {
        if (year > 2018) {
          return `令和${year - 2018}年`
        } else if (year > 1988) {
          return `平成${year - 1988}年`
        } else if (year > 1925) {
          return `昭和${year - 1925}年`
        } else if (year > 1911) {
          return `大正${year - 1911}年`
        } else if (year > 1867) {
          return `明治${year - 1867}年`
        } else {
          return year
        }
      }
    }
  },
  async created() {
    this.loading = true
    let p1 = this.fetchCountries()
    let p2 = this.fetchPrefectures()
    let p3 = this.fetchSaved()
    await Promise.all([p1, p2, p3])
    this.loading = false
  },
  computed: {
    ...mapGetters([
      'entryOpened',
      'isAfterRegistrationEnd',
      'isAfterWrittenExamTicketOpen',
      'isAfterWrittenExamResultOpen',
      'isAfterOralExamTicketOpen',
      'isAfterOralExamResultOpenAt'
    ]),
    submitted() {
      return this.$store.getters.submitted
    },
    requiredResubmit() {
      return this.$store.getters.requiredResubmit
    },
    hasSelectNationalityOther() {
      return this.form.nationality === 'その他'
    },
    minPictureDate() {
      return dayjs().subtract(3, 'month').format()
    },
    disableEditName() {
      if (this.isAfterRegistrationEnd) {
        return true
      }
      return this.submitted && !this.requiredResubmit
      // if (this.requiredResubmit) return false;
      // return (this.isAfterWrittenExamTicketOpen && !this.isAfterWrittenExamResultOpen)
      //   || (this.isAfterOralExamTicketOpen && !this.isAfterOralExamResultOpenAt)
    }
  },
  filters: {
    fileName(v) {
      return v && v.substring(v.lastIndexOf('/') + 1)
    }
  },
  watch: {},
  methods: {
    async checkZipcode(v, updateAddress) {
      //海外のzipcodeも可とする
      let ret = await this.findZipCode(v)
      if (!ret) {
        this.zipcodeInJapan = false
        return
      }
      this.zipcodeInJapan = true
      if (updateAddress) {
        this.form.prefecture = ret.prefecture
        this.form.address = ret.city + ret.street
      }
    },
    async checkZipcodeOffice(v, updateAddress) {
      //海外のzipcodeも可とする
      let ret = await this.findZipCode(v)
      console.log(ret, v, updateAddress)
      if (!ret) {
        // this.zipcodeInJapan = false
        return
      }
      // this.zipcodeInJapan = true
      if (updateAddress) {
        this.form.organizationPrefecture = ret.prefecture
        this.form.organizationAddress = ret.city + ret.street
      }
      console.log(ret, this.form.organizationPrefecture)
    },
    async checkNotifyZipcode(v) {
      this.notifyZipcodeError = [];
      let ret = await this.findZipCode(v)
      if (!ret) {
        this.notifyZipcodeError = '実在する日本国内の郵便番号ではありません'
      }
      this.form.notifyAddress = ret.prefecture + ret.city + ret.street
    },
    async checkJapanAddress(event, v) {
      if (!this.zipcodeInJapan) {
        await this.checkZipcode(this.form.zipcode)
      }
      if (!this.zipcodeInJapan) {
        event.preventDefault()
        event.stopPropagation()
        event.stopImmediatePropagation()
        alert('現住所に日本国内に存在しない郵便番号が入力されています。正しく入力してください。')
        this.form.notifySameAddress = false
        return false
      }
    },
    async fetchPrefectures() {
      this.prefectures = prefectures.map(v => v.name)
      this.prefectures.unshift('')
    },
    async fetchCountries() {
      this.countries = countries.map(v => v.companyjp)
      this.countries.push('その他')
      this.countries.unshift('')
    },
    async fetchSaved() {
      let {data} = await axios.get('/api/entry/draft')
      console.log('fetchSaved', data)
      if (data) this.form = Object.assign(this.form, data)
    },
    clickUpload() {
      if (this.disableEditName) return false
      if (this.submitted && !this.requiredResubmit) return false
      this.$refs.uploader.click()
    },
    onFileChanged(e) {
      this.uploadPhoto(e.target.files[0])
    },
    async uploadPhoto(file) {
      //size
      if (file.size > 10485760) {
        alert('ファイルサイズは10MB以下でアップロードしてください')
        return
      }
      this.isSelecting = true
      if (!file) {
        this.form.picture = null
        this.form.pictureUrl = null
        return
      }
      let params = new FormData()
      params.append('file', file)
      let {data} = await axios.post('/api/visitor/file/upload/photo', params)
      this.form.picture = data.id
      this.form.pictureUrl = data.url
      this.isSelecting = false
    },
    removeDocument(item) {
      this.form.documents = this.form.documents.filter(v => v.fileId != item.fileId)
    },
    async upload(file) {
      if (!file) return
      if (Array.isArray(file)) {
        this.loading = true
        try {
          for (let i in file) {
            await this.upload(file[i])
          }
        } catch (e) {
          console.error(e)
        }
        this.loading = false
        return
      }
      if (file.size > 20971520) {
        alert('ファイルサイズは20MB以下でアップロードしてください')
        return
      }
      let params = new FormData()
      params.append('file', file)
      let {data} = await axios.post('/api/visitor/file/upload', params)
      this.form.documents.push({
        fileId: data.id,
        key: file.name
      })
    },
    async save() {
      try {
        await axios.post('/api/entry/save', this.form)
        this.$emit('toast', '保存しました')
      } catch (e) {
        console.error(e)
        this.$emit('error', 'エラーが発生しました。しばらくしてから再度お試しください')
      }
    },
    async submit() {
      try {
        if (!this.$refs.form.validate()) {
          return
        }
        await axios.post('/api/entry/submit', this.form)
        this.$emit('toast', '確定しました')
        if (this.submitted) return
        await this.$router.push('/mypage')
      } catch (e) {
        console.error(e)
        this.$emit('error', 'エラーが発生しました。しばらくしてから再度お試しください')
      }
    }
  }
}
</script>
<style scoped>
h3 {
  font-size: 1rem;
  text-align: left;
  color: #363636;
  background-color: #F5F5F5;
  padding: 0.3rem;
}
</style>
<style>
.photo-message .v-messages {
  text-align: center;
}

.photo-message .v-input__slot {
  display: none;
}
</style>
